module.exports = __webpack_public_path__ + "img/splines-right.8922ed1.png";